import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import MenuSection from "./components/MenuSection";
import FacilitiesSection from "./components/FacilitiesSection";
import AccessSection from "./components/AccessSection";
import BookingSection from "./components/BookingSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-cream">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <MenuSection />
        <FacilitiesSection />
        <AccessSection />
        <BookingSection />
      </main>
      <Footer />
    </div>
  );
}